export const jobsReport = {
  toasts: {
    customReport: {
      saveSuccess: 'Changes successfully saved'
    }
  },
  customReports: {
    deleteModal: {
      title: 'Delete Report',
      content: 'Are you sure you want to delete this report?',
      toasts: {
        success: 'Custom report successfully deleted.'
      }
    },
    quickReports: {
      title: 'Create New Report',
      timeAndAttendance: {
        title: 'Time & Attendance',
        description: 'Detailed breakdown of costs of each job by clock in/out information'
      },
      roster: {
        title: 'Roster',
        description: 'Detailed breakdown of labor output of each job by worker'
      },
      custom: {
        title: 'Custom Report',
        description: 'Personalized job report based on customizable filters'
      }
    },
    emptyState: {
      title: 'Select a report to get started',
    },
    table: {
      title: 'My Reports',
      scheduleSummary: '%reportFrequency% at %deliveryTime% starting on %startOn%',
      noScheduleSummary: 'None',
      scheduled: 'Scheduled',
      scheduleReport: 'Schedule Report'
    }
  },
  actions: {
    saveReport: 'Save Report',
    scheduleReport: 'Schedule Report',
    saveChanges: 'Save Changes',
    editSchedule: 'Edit Schedule'
  },
  saveReportModal: {
    header: 'Save Report',
    reportSummary: {
      header: 'Report Summary',
      dateRange: 'Date Range: %dateRangeValue%',
      search: {
        none: 'Search: None',
        withKeyword: 'Search: %keyword%'
      },
      venue: {
        all: 'Location: All',
        withVenue: 'Location: %venues%'
      },
      status: {
        all: 'Status: All',
        withStatus: 'Status: %status%'
      },
      columns: 'Columns: %columns%'
    },
    formLabels: {
      name: 'Job Report Name',
      scheduleThisReport: 'Schedule Report',
      frequency: 'Frequency of delivery',
      time: 'Time',
      firstDelivery: 'First Delivery',
      recipients: 'Email Addresses'
    },
    actions: {
      cancel: 'Cancel',
      save: 'Save Report',
      saveAndSchedule: 'Save & Schedule'
    },
    frequencyOptions: {
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      annually: 'Annually'
    },
    errors: {
      name: 'Name cannot be blank',
      frequency: 'Frequency cannot be blank',
      invalidFrequencyValue: 'Frequency value is invalid',
      time: 'Time cannot be blank',
      invalidTimeValue: 'Time value is invalid',
      startOn: 'Start on cannot be blank',
      invalidStartOn: 'Start on date is invalid',
      recipients: 'Email Addresses cannot be blank',
      recipientsMinOne: 'Must have at least one selection'
    }
  },
  header: 'Job Reports',
  emptyState: {
    title: 'No results found',
    description: 'Try different keywords or expanding your date range.'
  },
  schedulePreview: {
    header: 'Schedule Summary',
    content: '%reportFrequency% at %deliveryTime% starting %startOn%. Sent to %recipients%'
  },
  filters: {
    header: 'Filters',
    searchPlaceholder: 'Wonoloer or job name',
    dateRange: {
      header: 'Date Range',
      LAST_THIRTY: 'Last 30 Days',
      LAST_SEVEN: 'Last 7 Days',
      NEXT_SEVEN: 'Next 7 Days',
      NEXT_THIRTY: 'Next 30 Days',
      custom: 'Custom'
    },
    venue: {
      label: 'Location'
    },
    status: {
      approved: 'Approved',
      readyToApprove: 'Ready to Approve',
      inProgress: 'In Progress',
      upcoming: 'Upcoming',
      unfilled: 'Unfilled',
      draft: 'Draft',
      cancelled: 'Cancelled',
      noShow: 'No Show',
    },
    quickReports: {
      title: 'Quick Reports:',
      options: {
        timeAndAttendance: 'Time and Attendance',
        roster: 'Roster'
      }
    },
    columnSelector: {
      label: 'Customize Columns'
    },
    reset: 'Reset'
  },
  table: {
    statusLabels: {
      filled: 'UPCOMING',
      in_progress: 'IN PROGRESS',
      completed: 'READY TO APPROVE',
      approved: 'APPROVED',
      cancelled: 'CANCELLED',
      no_show: 'NO SHOW',
    }
  }
};
